import Vue from "vue";
import Router from "vue-router";

import demoRoutes from "./portrait";
import cardRoutest from "./cardTest";
import lotteryRoutest from "./lottery";
import shake from "./shake";
import vip from "./vip";
import recall from "./recall";
import sheep from "./sheep";
import card from "./card";
import info from "./info";
import sanliouLinkage from "./sanliouLinkage";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/sakura",
  routes: [
    ...demoRoutes,
    ...cardRoutest,
    ...lotteryRoutest,
    ...shake,
    ...vip,
    ...recall,
    ...sheep,
    ...card,
    ...info,
    ...sanliouLinkage,
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/sakura/index.js